// extracted by mini-css-extract-plugin
export default {"root":"root___WFdUD","title":"title___Uwcmw"};